import { getAppDownloadUrl } from '@/shared-ui/organisms/app-promo-strip/app-promo-strip.shared';
import { getDevicePlatform } from '@/extensions/snk/lib/device-utils';

export type BuyInAppTarget = { type: 'navigate'; url: string } | { type: 'modal' };

/**
 * Where a Buy in App click goes: mobile opens the product's Optimove deep link, or the platform's
 * app store when there isn't one; desktop shows the QR overlay. Mirrors SFRA's `buyInApp.js`, minus
 * its `?redirectToAppStore=true` server hop.
 */
export const resolveBuyInAppTarget = (userAgent: string, optimoveUrl?: string): BuyInAppTarget => {
    if (!getDevicePlatform(userAgent)) return { type: 'modal' };
    return { type: 'navigate', url: optimoveUrl || getAppDownloadUrl(userAgent) };
};
